import { TExportSelectedData } from './export-data';
import { EExportData } from './export-data-enum';

export const points_simplelist_data: TExportSelectedData[] = [
  { name: 'Luerssen signature', id: EExportData.LUERSSEN_SIGNATURE },
];
